import { getResponseDetailFromBlobOrJson } from '../../utils/apiErrorDetail';
import { getHttpStatus } from '../../utils/httpErrorUtils';

/**
 * True only for the sign endpoint's explicit "screening unavailable —
 * acknowledge to sign" 422. The PDF call is a blob request, so the error body
 * must be parsed with the async blob-aware helper; any other 422 (e.g. a
 * validation failure) must NOT steer the clinician into acknowledging an
 * outage that never happened.
 */
export const needsScreeningAck = async (error: unknown): Promise<boolean> => {
  if (getHttpStatus(error) !== 422) return false;
  const detail = await getResponseDetailFromBlobOrJson(error);
  const message = typeof detail === 'string' ? detail : '';
  return /screen/i.test(message) || /acknowledg/i.test(message);
};
